import { postSanityData } from "./fetchServiceApi";

export const getParamUrl = (name)=> {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get(name);
}

export const getCategoriesUrl = () => {
  let requestUrl = location.href;
  let pattern  = 'categoria-producto';
  let lengthPattern = pattern.length;
  let start = requestUrl.indexOf(pattern) + lengthPattern + 1;
  let end = (requestUrl.indexOf('?') > 0)? requestUrl.indexOf('?') : 999;
  let extractUrl = requestUrl.substring(start, end);

  extractUrl = extractUrl.split('/');
  let segment1 = extractUrl[0] ? extractUrl[0]+'/' : '';
  let segment2 = extractUrl[1] ? extractUrl[1]+'/' : '';
  let segment3 = extractUrl[2] ? extractUrl[2]+'/' : '';
  extractUrl =  segment1 + segment2 + segment3;
  return extractUrl;
}

export const changeValueUrl = (key, value) =>{
  let queryParams = new URLSearchParams(window.location.search);
  queryParams.set(key, value);
  history.replaceState(null, null, "?"+queryParams.toString());
}

export const generateKeySmall = () => {
  return  '0eb81303'+ Math.floor(Math.random()*9999)+1000;
}

export const isMobile = ()=>{
  try {
    if (window.innerWidth < 768) {
      return true;
    } else {
      return false;
    }
  }catch (error) { 
  }
}

export const imageByResolution = (url, paramsPhone, paramsDesk)=>{
  if(isMobile()){
    return (paramsPhone) ? url+'?'+paramsPhone : url;
  }else{
    return (paramsDesk) ? url+'?'+paramsDesk : url;
  }
}

export const getBaseUrl = ()=>{
  try{
    return window.location.origin;
  }catch(e){}
}

export const makeUrlSite = (route)=>{
  return getBaseUrl()+'/'+route;
}

export const getParamsUrl = (param)=>{
  const urlString = window.location.href;
  const url = new URL(urlString);
  const searchParams = url.searchParams;
  return searchParams.get(param);
}

export const shortText = (text, length)=>{
  if(text.length < length){
    return text;
  }

  return text.substring(0, length)+'...';
}

export const roundDownToNearestTen = (number)=>{
  return Math.floor(number / 10) * 10;
}

export const getReferer = ()=>{
  return document.referrer;
}

export const getFullUrl = ()=>{
  return location.href;
}

export const getPathUrl = ()=>{
  const url = new URL(location.href);
  return url.pathname;
}

export const getPathName = ()=>{
  const url = new URL(getFullUrl());
  return url.pathname;
}

export const getPropertiesImage = (imageUrl, cbData)=>{
  if(imageUrl){
    const img = new Image();
    img.src = imageUrl;
    img.onload = () => {
      cbData({
        height: img.height,
        width: img.width
      });
    };
  }else{
    cbData({});
  }
}

export const timestampToDate = (timestamp)=>{
  const date = new Date(timestamp);
  const months = [
    "enero", "febrero", "marzo", "abril", "mayo", "junio",
    "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
  ];

  const day = date.getDate();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();

  const monthName = months[monthIndex];

  return `${day} ${monthName} ${year}`;
}

export const timestampToUTC = (timestamp)=>{
  let date = new Date(timestamp);
  return date.toISOString();
}

export const timestampToDateHour = (timestamp)=>{
  const date = new Date(timestamp);

  const day = date.getDate();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();
  const hour = date.getHours();
  const minute = date.getMinutes();

  return `${day}/${monthIndex}/${year} ${hour}:${minute}`;
}

export const defineEnviroment = ()=>{
  if(location.href.indexOf('vercel.app') > -1 || location.href.indexOf('localhost') > -1){
    return 'PRUEBAS';
  }else{
    return 'PRODUCTION'
  }
}

export const isLocal = ()=>{
  if(location.href.indexOf('localhost') > -1){
    return true;
  }
  return false;
}

export const isStaging = ()=>{
  if(location.href.indexOf('vercel.app') > -1){
    return true;
  }
  return false;
}

export const isProduction = ()=>{
  if(location.href.indexOf('ellibrero.com') > -1){
    return true;
  }
  return false;
}

export const valueByEnviroment = (dev, prod)=>{
  if(defineEnviroment() === 'PRUEBAS'){
    return dev;
  }else{
    return prod;
  }
}

export const hasUrlSection = (sectionName)=> {
  try{
    const queryString = window.location.href;
    return queryString.indexOf(sectionName) > -1;
  }catch(e){
    return false;
  }
}

export const valueByEnviromentExtend = (local, staging,  prod)=>{
  try{
    if(isLocal()){
      return local;
    }else if(isStaging()){
      return staging;
    }else if(isProduction()){
      return prod;
    }
  }catch(e){}
}

/*

*/
export const appendValueToUrlParam = (section, itemName)=>{
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  
  let categories = params.get(section) ? params.get(section)?.split("|") : [];
  if (categories && !categories.includes(itemName)) {
      categories.push(itemName);
  }else{
    categories = categories ? categories.filter((item)=>{return item !== itemName}) : [];
  }

  if(categories.length < 1){
    params.delete(section);
  }else{
    params.set(section, categories.join("|"))
  }

  window.history.pushState({}, "", `${url.pathname}?${params.toString()}`);
}

export const resetValueParamUrl = (section)=>{
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  params.set(section,'');
  window.history.pushState({}, "", `${url.pathname}?${params.toString()}`);
}

/**
 *  TRACK SPEED
*/
const TRACK_SPEED_DATA = {
  time: 0,
  enable: false
};

export const trackSpeed = (process, data)=>{
  const COVERAGE = 7;
  
  if(defineEnviroment() !== 'PRODUCTION'){
    return false;
  }

  if(process === 'start'){
    const randomNumber = Math.floor(Math.random() * 10) + 1;

    if(randomNumber > COVERAGE){
      TRACK_SPEED_DATA.time = Date.now();
      TRACK_SPEED_DATA.enable = true;
    }
  }else if(TRACK_SPEED_DATA.enable && process === 'end'){
    
    data.func = 'saveLogSpeed';
    data.link = getFullUrl();
    data.speed = Date.now() - TRACK_SPEED_DATA.time;

    postSanityData('/api/sanity/admin-front', data)
    .then((reponse)=>{
      TRACK_SPEED_DATA.time = 0;
      TRACK_SPEED_DATA.enable = false;
    })
  }
}

/**
 *  --TRACK SPEED
*/

export const encriptUrlData = (data)=>{
  return encodeURIComponent(btoa(data));
}

export const decriptUrlData = (data)=>{
  return decodeURIComponent(atob(data));
}

export const isEmpty = (value)=>{
  if(value === '' || !value || value === '[]' || value?.length === 0 || value === 'undefined' || value === undefined){
    return true;
  }
  return false;
}